import React from 'react'

const TeacherDash = () => {
  return (
    <div>TeacherDash</div>
  )
}

export default TeacherDash